/**
 * Cookie consent popup (Shopify's native customerPrivacy API).
 */
class CookieConsentPopup extends HTMLElement {
  constructor() {
    super();
    this.onAccept = this.onAccept.bind(this);
    this.onDecline = this.onDecline.bind(this);
  }

  connectedCallback() {
    this.cookieName = this.dataset.cookieName || 'cookie_consent';
    this.acceptButton = this.querySelector('[data-cookie-accept]');
    this.declineButton = this.querySelector('[data-cookie-decline]');

    this.acceptButton?.addEventListener('click', this.onAccept);
    this.declineButton?.addEventListener('click', this.onDecline);

    if (!window.Shopify?.loadFeatures) return;

    window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
      if (error) return;

      const canBeTracked = window.Shopify.customerPrivacy.userCanBeTracked();
      const consent = window.Shopify.customerPrivacy.getTrackingConsent();
      const hasInteracted = consent !== 'no_interaction' || this.readCookie() !== null;

      if (!canBeTracked && !hasInteracted) this.open();
    });
  }

  disconnectedCallback() {
    this.acceptButton?.removeEventListener('click', this.onAccept);
    this.declineButton?.removeEventListener('click', this.onDecline);
  }

  onAccept() {
    this.onChoice(true);
  }

  onDecline() {
    this.onChoice(false);
  }

  open() {
    this.classList.add('is-open');
    document.body.classList.add('cookie-consent-open');
  }

  close() {
    this.classList.remove('is-open');
    document.body.classList.remove('cookie-consent-open');
  }

  /**
   * Stores the dismissal cookie and passes the choice to Shopify.
   * @param {boolean} accepted - Whether the visitor accepted tracking
   */
  onChoice(accepted) {
    this.writeCookie();
    window.Shopify.customerPrivacy.setTrackingConsent(accepted, () => this.close());
  }

  writeCookie() {
    const expires = new Date(Date.now() + 365 * 24 * 60 * 60 * 1000).toUTCString();
    document.cookie = `${this.cookieName}=user_has_closed; expires=${expires}; path=/; SameSite=Lax`;
  }

  /**
   * @returns {string|null} The stored cookie value, or null when unset
   */
  readCookie() {
    const match = document.cookie.split('; ').find((row) => row.startsWith(`${this.cookieName}=`));
    return match ? match.split('=')[1] : null;
  }
}

if (!customElements.get('cookie-consent-popup')) {
  customElements.define('cookie-consent-popup', CookieConsentPopup);
}
